import React from 'react';
import './PlaceCard.css';

const PlaceCard = ({ place, onClick }) => {
    return (
        <div className="place-card" onClick={() => onClick(place)}>
            <div className="place-card-header">
                {place.mainImageUrl && (
                    <img src={place.mainImageUrl} alt={place.nombreL} className="place-card-image" />
                )}
                <h3>{place.nombreL}</h3>
            </div>
            <div className="place-card-body">
                <p><strong>Referencia:</strong> {place.referencia}</p>
            </div>
        </div>
    );
};

export default PlaceCard;
